import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { emptyInProgress } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectInProgressEpisodeIds,
  selectPlayerSessionsResult,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EmptyView } from '../EmptyView';

export const InProgress = () => {
  const compliance = useSelector(selectUserCompliance);
  const { isSuccess: isPlayerSessionsSuccess } = useSelector(
    selectPlayerSessionsResult,
  );
  const inProgressEpisodeIds = useSelector(selectInProgressEpisodeIds);

  const {
    data: episodes = [],
    isLoading,
    isSuccess,
  } = useFetchEpisodesQuery(
    {
      episodeIds: inProgressEpisodeIds,
      compliance,
    },
    {
      skip: !inProgressEpisodeIds.length,
    },
  );

  const isEmpty =
    (isPlayerSessionsSuccess && !inProgressEpisodeIds.length) ||
    (isSuccess && !episodes.length);

  return (
    <Box>
      {isEmpty ? (
        <EmptyView
          title="Start your next listen"
          subtitle="Explore the library to find a new, trending or special feature episode."
          img={emptyInProgress}
        />
      ) : (
        <EpisodeGrid
          isLoading={isLoading}
          episodes={episodes}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.MY_LUMIQ,
            section: EVENT_CONSTANTS.SECTION.IN_PROGRESS,
          }}
        />
      )}
    </Box>
  );
};
